import { Fragment, useContext, useState } from "react";
import { Link } from "react-router-dom";
import { DropdownItem } from "reactstrap";
import ActionOptions from "../../Common/Component/ActionOptions";
import CustomizerContext from "../../../_helper/Customizer";
import ServiceCityDeleteModal from "../Modals/ServiceCityDeleteModal";
import StatusBadge from "../../Common/Component/StatusBadge";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";

const ServiceCityTable = ({
  loader,
  setRowsPerPage,
  rowsPerPage,
  setLoader,
  serviceCityData = [],
  fetchData,
  paginationTotalRows,
  trgiggerRefresh,
  onChangePage,
  onChangeRowsPerPage,
  onEditClick,
  pagination,
}) => {
  const { mix_background_layout } = useContext(CustomizerContext);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteObj, setDeleteObj] = useState({});

  const toggleDeleteModal = () => setDeleteModal(!deleteModal);

  const handleChangePage = (event, newPage) => {
    onChangePage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    onChangeRowsPerPage(parseInt(event.target.value, 10));
  };

  return (
    <Fragment>
        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            backgroundColor: "transparent",
            maxHeight: "57vh",
            overflowY: "auto",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            boxShadow: "0 4px 10px 1px rgba(8, 8, 8, 0.15)",
          }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow
                sx={{
                  "& th": {
                    color: "#626262",
                    fontWeight: "bold",
                    fontSize: "14px",
                    backgroundColor: "#E1F4E4",
                    borderBottom: "none",
                    whiteSpace: "nowrap",
                  },
                }}
              >
                <TableCell>Name</TableCell>
                <TableCell>City Code</TableCell>
                <TableCell>Aggregator Name</TableCell>
                <TableCell>Company Name</TableCell>
                <TableCell>Place of Supply</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="center" sx={{ width: "80px" }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loader ? (
                [...Array(rowsPerPage)].map((_, index) => (
                  <TableRow key={index}>
                    <TableCell><Skeleton animation="wave" /></TableCell>
                    <TableCell><Skeleton animation="wave" /></TableCell>
                    <TableCell><Skeleton animation="wave" /></TableCell>
                    <TableCell><Skeleton animation="wave" /></TableCell>
                    <TableCell><Skeleton animation="wave" /></TableCell>
                    <TableCell><Skeleton animation="wave" /></TableCell>
                    <TableCell><Skeleton animation="wave" /></TableCell>
                  </TableRow>
                ))
              ) : serviceCityData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} align="center" sx={{ py: 3 }}>
                    No Service Cities found
                  </TableCell>
                </TableRow>
              ) : (
                serviceCityData.map((row) => (
                  <TableRow
                    key={row.id}
                    sx={{
                      // backgroundColor: row.isDeleted ? "#F9B5A6" : "inherit",
                      // "&:hover": {
                      //   backgroundColor: row.isDeleted ? "#F9B5A6 !important" : "#EBEBEB",
                      //   cursor: "pointer",
                      // },
                      "& td": {
                        borderBottom: "none",
                        fontSize: "14px",
                        color: "#313131",
                      },
                    }}
                  >
                    <TableCell>
                      <Link
                        to={`${process.env.PUBLIC_URL}/configurations/service-city-details/${row.id}`}
                        style={{
                          color: "#39B54A",
                          fontWeight: "600",
                          fontSize: "15px",
                          textDecoration: "none",
                        }}
                      >
                        {row.name || "-"}
                      </Link>
                    </TableCell>
                    <TableCell>{row.cityCode || "-"}</TableCell>
                    <TableCell>{row.aggregatorCompanyName || "-"}</TableCell>
                    <TableCell>{row.companyName || "-"}</TableCell>
                    <TableCell>{row.placeOfSupply || "-"}</TableCell>
                    <TableCell>
                      <StatusBadge isDeleted={row.isDeleted} />
                    </TableCell>
                    <TableCell align="center">
                      <ActionOptions key={row.id}>
                        <Fragment>
                          <DropdownItem
                            className="border-0"
                            key={"row-edit"}
                            onClick={() => {
                              setDeleteObj(row);
                              toggleDeleteModal();
                            }}
                          >
                            {row.isDeleted ? (
                              <i className="fa fa-recycle" />
                            ) : (
                              <i className="fa fa-trash-o" />
                            )}{" "}
                            {row.isDeleted ? "Recover" : "Delete"}
                          </DropdownItem>
                          <DropdownItem
                            className="border-0"
                            key={"row-edit-form"}
                            onClick={() => {
                              onEditClick(row.id);
                            }}
                          >
                            <i className="fa fa-pencil" /> Edit
                          </DropdownItem>
                        </Fragment>
                      </ActionOptions>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={paginationTotalRows}
          page={pagination}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
          sx={{
            "& .MuiTablePagination-toolbar": {
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: 2,
              textAlign: "center",
              overflowX: "hidden",
            },
            "& .MuiTablePagination-select": {
              backgroundColor: "rgba(255, 255, 255, 1)",
              borderRadius: "6px",
              border: "1px solid #D9D9D9",
            },
            "& .MuiTablePagination-actions button": {
              color: "rgba(112, 112, 112, 1)",
              transform: "scale(1.3)",
            },
            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
              color: "rgba(98, 98, 98, 1)",
              fontSize: "14px",
              textAlign: "center",
              m: "auto",
              letterSpacing: "0.02vw",
            },
          }}
        />

      <ServiceCityDeleteModal
        LargeModaltoggle={toggleDeleteModal}
        Large={deleteModal}
        deleteObj={deleteObj}
        fetchData={fetchData}
      />
    </Fragment>
  );
};

export default ServiceCityTable;
